import React from "react";

const SvgChevronRight = props => <svg viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M8.293 15.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 1.414L13.586 10l-5.293 5.293z" /></svg>;

export default SvgChevronRight;